import { render, staticRenderFns } from "./inventory-summary.vue?vue&type=template&id=44ebc898&scoped=true&"
import script from "./inventory-summary.vue?vue&type=script&lang=js&"
export * from "./inventory-summary.vue?vue&type=script&lang=js&"
import style0 from "./inventory-summary.vue?vue&type=style&index=0&id=44ebc898&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ebc898",
  null
  
)

export default component.exports